export type AppConfig = {
    apiPrefix: string
    authenticatedEntryPath: string
    unAuthenticatedEntryPath: string
    tourPath: string
    locale: string
    enableMock: boolean,
    dbName: string
 }
 
 
 const appConfig: AppConfig = {
    apiPrefix: import.meta.env.VITE_SERVER_BASE_URL,
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'en',
    enableMock: true,
    dbName: 'local',
 }
 
 
 export default appConfig